import { Typography } from '@mui/material';

const PaginationInfo = ({
  currentPage,
  perPage,
  totalCount,
  showText = 'Showing',
  showCenter = true,
  showRowCount = false,
  setPerPage,
}) => {
  if (totalCount === 0) return null;

  const startRecord = (currentPage - 1) * perPage + 1;
  const endRecord = Math.min(currentPage * perPage, totalCount);

  let displayMessage = '';
  if (totalCount === 1) {
    displayMessage = `${showText} ${startRecord} of ${totalCount} record`;
  } else {
    displayMessage = `${showText} ${startRecord} to ${endRecord} of ${totalCount} records`;
  }
  const PAGE_SIZES = [10, 25, 50, 100];

  return (
    <div
      className={
        showCenter
          ? 'text-center m-2'
          : 'text-end m-1 d-flex align-items-center flex-direction-row gap-4'
      }>
      {showRowCount && (
        <div className="d-flex align-items-center gap-1">
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: 'nowrap', mb: 0 }}>
            Rows per page:
          </Typography>
          <select
            onChange={setPerPage}
            value={perPage}
            style={{
              height: '2em',
              borderRadius: '4px',
              border: '1px solid #ced4da',
              padding: '0 px',
              width: '50px',
              fontSize: '14px',
            }}>
            {PAGE_SIZES.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
      )}
      <small>{displayMessage}</small>
    </div>
  );
};

export default PaginationInfo;
